export default __webpack_public_path__ + "pump.png?258c1365694588d62e792feb5a09203e";